'use client'
import { PrismicRichText, PrismicImage, PrismicLink } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import '@splidejs/react-splide/css/core';

/**
 * @typedef {import("@prismicio/client").Content.LogoListSlice} LogoListSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LogoListSlice>} LogoListProps
 * @type {import("react").FC<LogoListProps>}
 */
const LogoList = ({ slice }) => {
  const originalLogos = slice.primary.logos || [];
  let logos = [...originalLogos];
  if (logos.length > 0 && logos.length < 8) {
    logos = [...logos, ...logos, ...logos, ...logos, ...logos];
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-beige flex items-center pl-5 md:pl-20 py-4 ${slice.variation === "default" ? "text-moyam-orange" : "text-dark-green"} overflow-hidden`}
    >
      {isFilled.richText(slice.primary.text) && (
        <div className="shrink-0 pr-4 md:pr-8 relative">
          <PrismicRichText
            field={slice.primary.text}
            components={{
              heading2: ({ children }) => <h2 className="h4 md:h3 w-25 md:w-full">{children}</h2>,
              heading3: ({ children }) => <h3 className="h4 md:h3 w-25 md:w-full">{children}</h3>,
              heading4: ({ children }) => <h4 className="h4 md:h3 w-25 md:w-full">{children}</h4>,
            }}
          />
        </div>
      )}

      {isFilled.group(slice.primary.logos) && (
        <div className="flex-1 md:pr-6">
          <Splide
            extensions={{ AutoScroll }}
            options={{
              type: "loop",
              gap: "2.5rem",
              autoWidth: true,
              pagination: false,
              arrows: false,
              drag: "free",
              padding: { left: "2rem", right: 0 },
              autoScroll: {
                speed: 0.6,
                pauseOnHover: false,
                pauseOnFocus: false,
                rewind: false,
              },
              breakpoints: {
                768: {
                  gap: "1.5rem",
                },
              },
            }}
            aria-label="Liste des logos"
          >
            {logos.map((logo, index) => (
              <SplideSlide key={index} className="flex items-center justify-center">
                {isFilled.image(logo.img) && isFilled.link(logo.link) ? (
                  <PrismicLink field={logo.link}>
                    <PrismicImage
                      field={{
                        ...logo.img,
                        alt: logo.img.alt || "Logo d'illustration"
                      }}
                      className="h-6.5 w-auto object-contain"
                    />
                  </PrismicLink>
                ) : isFilled.image(logo.img) ? (
                  <PrismicImage
                    field={{
                      ...logo.img,
                      alt: logo.img.alt || "Logo d'illustration"
                    }}
                    className="h-6.5 w-auto object-contain"
                  />
                ) : null}
              </SplideSlide>
            ))}
          </Splide>
        </div>
      )}
    </section>
  );
};

export default LogoList;